import request from '@/utils/request'

export function getNewsList(params) {	
  return request({
      url: '/system/news/news/interior/list',
      method: 'get',
      params
 })
}
